import React, { useRef } from "react";
import _ from "lodash";
import TYPE from "../../../../constant/TYPE";
import { getMathJaxNode } from "../../mathjax/MathJax";
import Process2 from "./Process2";

const CyclicDecimal = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.CYCLIC_DECIMAL }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.CYCLIC_DECIMAL }}`;

  const mapData = ( value, index ) => {
    if ( 2 === index ) {
      return value.slice( value.indexOf( '\\begin{align}' ) + '\\begin{align}'.length, value.indexOf( '\\end{align}' ) ).split( '&' ).map( v => v.trim() );
    } else {
      return value.trim();
    }
  };

  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '\\\\' ).map( mapData );
  const changedDataCount = data.reduce( ( r, v, i ) => r + ( _.isEqual( prevData.current[ i ], v ) ? 0 : 1 ), 0 );

  const MathJaxNode = getMathJaxNode( props.type );

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  return (
    <div>
      <div className="ta-l"><MathJaxNode onRender={ renderMathJax }>{ data[ 0 ] || '' }</MathJaxNode></div>
      <div className="mt10 ta-l"><MathJaxNode onRender={ renderMathJax }>{ data[ 1 ] || '' }</MathJaxNode></div>
      <Process2 data={ data[ 2 ] } onRender={ renderMathJax } />
      <div className="mt10 ta-l"><MathJaxNode onRender={ renderMathJax }>{ data[ 3 ] || '' }</MathJaxNode></div>
    </div>
  );

};

export default CyclicDecimal;
